import React from 'react';
import SideBarMobile from '../../../shared/templates/CategoryTemplate/category-sidebar-mobile';

function EventsSideBarMobile(props) {
  return (<SideBarMobile {...props}
    section="events"
    searchTitle="Search Events"
    createNewTitle="New Event"
    filterList={[
      { name: 'keywords', value: 'Enter Keywords' },
    ]}
  />);
}

export default EventsSideBarMobile;